// Vendor libs
import * as Cookie from 'app/packages/cookie-utils';
import changeWindowLocation from 'app/common/lib/util/changeWindowLocation';

import urlUtil from 'app/common/lib/urlUtil';

const COOKIE_PREFIX = 'offsite_';
const TOKEN_DELIMITER = '-';

const SafeLink = {
  /**
   * Open a link in the OffsitePage.
   *
   * @param {string} url The url.
   * @param {?string} pinId The id of the pin where this link
   *  may have come from.
   * @param {?string} csrId The id of the crawled search result where this link
   *  may have come from.
   * @param {?string} clientTrackingParams
   * @param {?object} auxData Additional logging metadata
   */
  open(url, pinId, csrId, clientTrackingParams, auxData) {
    const tokenKey = Math.round(Math.random() * 1000) + '';
    const tokenValue = Math.round(Math.random() * 1000) + '';

    // We set a cookie with a unique name and value. Using a
    // unique key will help prevent conflicts that can happen
    // when setting a cookie from different sub domains and
    // protocols.
    Cookie.set(COOKIE_PREFIX + tokenKey, tokenValue);

    const query = {
      token: tokenKey + TOKEN_DELIMITER + tokenValue,
      url,
    };

    if (pinId) {
      query.pin = pinId;
    } else if (csrId) {
      query.csr = csrId;
    }

    if (clientTrackingParams) {
      query.client_tracking_params = clientTrackingParams;
    }

    if (auxData) {
      query.aux_data = JSON.stringify(auxData);
    }

    changeWindowLocation('/offsite/?' + urlUtil.getQueryStringFromObject(query), true);
  },
};

export default SafeLink;
